import { SwitchField } from '@/components/form/fields/SwitchField';
import { Checkbox, Input, Radio, Select } from 'alurkerja-ui';
import React from 'react';

type CustomFieldInputProps = {
  label: string;
  enabled?: boolean;
  onClick: () => void;
};

const customField = [
  {
    value: (
      <Checkbox
        listOption={[
          { label: 'Checkbox 1', value: 'test' },
          { label: 'Checkbox 2', value: 'test' },
        ]}
        disabled
        defaultValue={['test']}
      />
    ),
    name: 'Check Boxes',
  },
  {
    value: (
      <Select
        placeholder="Select Value 1"
        isDisabled
      />
    ),
    name: 'Select Dropdown',
  },
  {
    value: (
      <Radio
        name="radio"
        listOption={[
          { label: 'Radio Button 1', key: 1 },
          { label: 'Radio Button 2', key: 2 },
        ]}
        defaultValue={1}
        disabled
      />
    ),
    name: 'Radio Buttons',
  },
  {
    value: <Input placeholder="Input Field" disabled />,
    name: 'Input Fields',
  },
  {
    value: <Input textArea placeholder="Text Area" disabled />,
    name: 'Text Area Fields',
  },
  {
    value: (
      <Select
        isDisabled
      />
    ),
    name: 'Multi Select',
  },
  {
    value: <Input placeholder="Url Link Input" type="link" disabled />,
    name: 'Url Link Input',
  },
];

export const CustomFieldInput: React.FC<CustomFieldInputProps> = ({
  label,
  enabled,
  onClick,
}) => {
  const matchingField = customField.find(field => field.name === label);

  const preview = matchingField ? matchingField.value : null;
  return (
    <div className="border-t-2">
      <div className="mt-4 grid grid-cols-2 items-center">
        <div className="w-1/2">{preview}</div>
        <div className="flex justify-between">
          <div>{label}</div>
          <button onClick={onClick}>
            <SwitchField name="" isEnabled={enabled ?? false} />
          </button>
        </div>
      </div>
    </div>
  );
};
